import indigo from "./AboutImages/IndiGo.jpg";
import akasa from "./AboutImages/akasa.png";
import qatar from "./AboutImages/qatar.png";
import emirates from "./AboutImages/emirates.png";
import etihad from "./AboutImages/etihad.png";
import airindia from "./AboutImages/airindia.png";
import singair from "./AboutImages/singair.png";

const partners = [
  {
    name: "Emirates",
    logo: emirates,
  },
  {
    name: "Qatar Airways",
    logo: qatar,
  },
  {
    name: "Singapore Airlines",
    logo: singair,
  },
  {
    name: "Air India",
    logo: airindia,
  },
  {
    name: "IndiGo",
    logo: indigo,
  },
  {
    name: "Etihad Airways",
    logo: etihad,
  },
  {
    name: " Akasa Air",
    logo: akasa,
  },
];

export default partners;
